export default "__VITE_ASSET__C$K0dkOi__"